import { useTranslate } from '@tolgee/react';
import React, { useState } from 'react';
import TemplateCard from './templateCard';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

interface TemplateProps {
  data: any;
}

const MessageTemplateCard: React.FC<TemplateProps> = ({ data }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();

  const template = data?.template_data;
  const sendTemplateForm =
    data?.whatsapp_template_sending?.template?.components;

  const replacePlaceholders = (text: string, values?: any[]) => {
    if (!values) return text;

    return text.replace(/{{(\d+|[\w_]+)}}/g, (match, key) => {
      const numericIndex = parseInt(key, 10) - 1;

      // If it's a number, replace it with the corresponding text from values
      if (!isNaN(numericIndex) && values[numericIndex]?.text) {
        return values[numericIndex].text;
      }

      // If it's a named parameter, find and replace it
      const namedParam = values.find((p) => p.parameter_name === key);
      if (namedParam) {
        return namedParam.text;
      }

      // If no match is found, return the original placeholder
      return match;
    });
  };

  const updatedTemplate = {
    ...template,
    components: template?.components?.map((component) => {
      if (component.type === 'HEADER') {
        const headerParams =
          sendTemplateForm.find((x) => x.type === 'header')?.parameters || [];

        return {
          ...component,
          example: {
            ...component.example,
            ...(headerParams.some((p) => p.parameter_name)
              ? {
                  header_text_named_params: headerParams
                    .filter((p) => p.parameter_name)
                    .map((item) => ({
                      param_name: item?.parameter_name,
                      example: item?.text
                    }))
                }
              : { header_text: headerParams.map((p) => p.text) })
          }
        };
      }

      if (component.type === 'BODY') {
        const bodyParams =
          sendTemplateForm.find((x) => x.type === 'body')?.parameters || [];

        return {
          ...component,
          example: {
            ...component.example,
            ...(bodyParams.some((p) => p.parameter_name)
              ? {
                  body_text_named_params: bodyParams
                    .filter((p) => p.parameter_name)
                    .map((item) => ({
                      param_name: item?.parameter_name,
                      example: item?.text
                    }))
                }
              : { body_text: [bodyParams.map((p) => p.text)] })
          }
        };
      }

      // Handling BUTTONS
      if (component.type === 'BUTTONS') {
        const buttonParamsList = sendTemplateForm.filter(
          (x) => x.type === 'button' && 'index' in x
        ) as Array<{ type: string; index: number; parameters: any[] }>;

        return {
          ...component,
          buttons: component.buttons.map((button, index) => {
            const buttonParams =
              buttonParamsList.find((x) => x.index === index)?.parameters || [];

            return {
              ...button,
              url: button.url
                ? replacePlaceholders(button.url, buttonParams)
                : button.url
            };
          })
        };
      }

      return component;
    })
  };

  console.log('form', sendTemplateForm, updatedTemplate);

  return (
    <div style={{ width: 280 }}>
      <TemplateCard template={updatedTemplate} cardOnly={true} />
    </div>
  );
};

export default MessageTemplateCard;
